<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('data.import_title')"></page-header-title>
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex xs12 class="pa-3">
          <v-select
            name="report"
            v-model="selectedModule"
            item-text="text"
            item-value="key"
            :items="modules"
            :label="$t('data.select_module')"
            clearable
            hide-details
          ></v-select>
        </v-flex>
      </v-card-text>
    </v-card>

    <v-card class="mt-3" v-if="selectedModule">
      <v-card-text class="pa-2">
        <v-flex xs12> </v-flex>
        <v-flex xs12>
          <v-file-input v-model="file" accept=".xlsx" :label="$t('data.select_import_template')"></v-file-input>
          <action-button type="download" :text="$t('data.download_import_template')" @click="downloadTemplate" />
          <action-button type="upload" :text="$t('data.import_file')" @click="importData" :disabled="!file" />
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Import",

  data() {
    return {
      modules: [
        { key: "participants", text: this.$t("participants.title") },
        { key: "students_studentgroups", text: this.$t("data.student_to_groups") },
        { key: "studentgroups", text: this.$t("studentgroups.title") },
        { key: "users", text: this.$t("users.title") }
      ],
      file: null,
      selectedModule: null
    }
  },

  created() {},

  methods: {
    downloadTemplate() {
      if (this.selectedModule) {
        let filename = this.selectedModule
        let url = this.API_URL + this.selectedModule + "/download-template"

        if (this.selectedModule == "students_studentgroups") {
          url = this.API_URL + "participants/studentgroups/download-template"
        }

        axios({
          url: url,
          method: "POST",
          responseType: "arraybuffer"
        }).then((response) => {
          if (this.$arrayBufferValidation(response.data)) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement("a")

            if (this.selectedModule == "participants") {
              filename = "students"
            }

            link.href = url
            link.setAttribute("download", filename + "_template.xlsx")
            link.click()
          }
        })
      }
    },
    importData() {
      let vm = this

      if (this.selectedModule) {
        let url = this.API_URL + this.selectedModule + "/import"

        if (this.selectedModule == "students_studentgroups") {
          url = this.API_URL + "participants/studentgroups/import"
        }

        let formData = new FormData()
        formData.append("module", this.selectedModule)
        formData.append("file", this.file)

        axios
          .post(url, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then((res) => {
            let status = res.data.status
            if (status == "success") {
              vm.$awn.success(vm.$t("data.import_success"))
            } else if (status == "invalid-file") {
              vm.$awn.alert(vm.$t("data.invalid_file"))
            } else {
              vm.$awn.alert(vm.$t("data.import_failed"))
            }

            this.file = null
          })
          .catch((err) => vm.$awn.alert(vm.$t("data.import_failed")))
      }
    }
  }
}
</script>
